import * as React from 'react';
import {EXPORT_MODAL} from '../../constants/LabelConstants';

const ApprovedApplicationsExportVolumeView: React.FC<{data: {total: number}}> = ({data}) => (
    <div className="col-12 p-0">
        <p className="text-justify">{EXPORT_MODAL.volumeText(data.total)}</p>
        <p className="text-justify mb-0">{EXPORT_MODAL.VOLUME_SUBTEXT}</p>
    </div>
);

export default ApprovedApplicationsExportVolumeView;
